//natives
import React, { Component, createRef } from 'react';
import Cookies from 'universal-cookie';
import { Helmet } from 'react-helmet';
// import TagManager from 'react-gtm-module';

//childrens
import Tabs from '../childrens/tabs/.mixins';
import Filter from '../childrens/filter/.mixins';
import ModalFichaTecnicaSucesso from '../childrens/tabs/childrens/modals/modalFichaTecnicaSucesso/.mixins';

import HelperGenericos from './helpers/helper_genericos';
import HelperAcessorios from './helpers/helper_acessorios';
import HelperMoveis from './helpers/helper_moveis';
import { AuthContext } from '../../../../../../contexts/AuthContext';

import StateAcessorios from './states/state_acessorios';
import StateMoveis from './states/state_moveis';
import StateGenericos from './states/state_genericos';

//components
import Cabecario from '../../../../../util/cabecario/.mixins';
import Alerta from "../../../../../util/snackbars/.mixins";
import Loader from '../../../../../util/loader/.mixins';
import { Snackbar as SnackbarFilterValidation } from '../childrens/snackbar';

//controllers
import Log from '../../../../../../controllers/log';

export default class Qualidade extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.childAlert = createRef();
    this.childUploadAcessorios = createRef();
    this.childUploadMoveis = createRef();
    this.isVisaoTok = false;
    this.permissions = {};

    this.state = {
      ...StateGenericos,
      ...StateAcessorios,
      ...StateMoveis,
    };

    /*
        ACESSORIOS - Begin
    */
    this.loadAcessorios = this.loadAcessorios.bind(this);

    this.handlerLoadSearchFilterTagAcessorios = this.handlerLoadSearchFilterTagAcessorios.bind(this);

    this.handlerSelectCheckboxAcessorios = this.handlerSelectCheckboxAcessorios.bind(this);
    this.handlerClickCheckboxAcessorios = this.handlerClickCheckboxAcessorios.bind(this);

    this.handlerChangeSearchFieldAcessorios = this.handlerChangeSearchFieldAcessorios.bind(this);
    this.handlerChangeSearchFieldExternalAcessorios = this.handlerChangeSearchFieldExternalAcessorios.bind(this);
    this.handlerClickSearchFieldExternalAcessorios = this.handlerClickSearchFieldExternalAcessorios.bind(this);

    this.handlerChangeStatusAcessorios = this.handlerChangeStatusAcessorios.bind(this);
    this.handlerChangeSituacoesAcessorios = this.handlerChangeSituacoesAcessorios.bind(this);
    this.handleChangeGruposAcessorios = this.handleChangeGruposAcessorios.bind(this);
    this.handleChangeFamiliasAcessorios = this.handleChangeFamiliasAcessorios.bind(this);
    this.handleChangeGruposMoveis = this.handleChangeGruposMoveis.bind(this);
    this.handleChangeFamiliasMoveis = this.handleChangeFamiliasMoveis.bind(this);
    this.disableSelectFamiliasMoveis = this.disableSelectFamiliasMoveis.bind(this);
    this.disableSelectFamiliasAcessorios = this.disableSelectFamiliasAcessorios.bind(this);

    this.handlerCleanFiltersAcessorios = this.handlerCleanFiltersAcessorios.bind(this);
    this.handlerAplicarFiltersAcessorios = this.handlerAplicarFiltersAcessorios.bind(this);

    this.handlerCheckboxAllAcessorios = this.handlerCheckboxAllAcessorios.bind(this);

    this.onChangePageAcessorios = this.onChangePageAcessorios.bind(this);
    this.onChangeFileAcessorios = this.onChangeFileAcessorios.bind(this);
    this.onUpFileAcessorios = this.onUpFileAcessorios.bind(this);
    /*
        ACESSORIOS - End
    */

    /*
        MOVEIS - Begin
    */
    this.loadMoveis = this.loadMoveis.bind(this);

    this.handlerLoadSearchFilterTagMoveis = this.handlerLoadSearchFilterTagMoveis.bind(this);

    this.handlerSelectCheckboxMoveis = this.handlerSelectCheckboxMoveis.bind(this);
    this.handlerClickCheckboxMoveis = this.handlerClickCheckboxMoveis.bind(this);

    this.handlerChangeSearchFieldMoveis = this.handlerChangeSearchFieldMoveis.bind(this);
    this.handlerChangeSearchFieldExternalMoveis = this.handlerChangeSearchFieldExternalMoveis.bind(this);
    this.handlerClickSearchFieldExternalMoveis = this.handlerClickSearchFieldExternalMoveis.bind(this);

    this.handlerChangeStatusMoveis = this.handlerChangeStatusMoveis.bind(this);
    this.handlerChangeSituacoesMoveis = this.handlerChangeSituacoesMoveis.bind(this);

    this.handlerCleanFiltersMoveis = this.handlerCleanFiltersMoveis.bind(this);
    this.handlerAplicarFiltersMoveis = this.handlerAplicarFiltersMoveis.bind(this);

    this.handlerCheckboxAllMoveis = this.handlerCheckboxAllMoveis.bind(this);

    this.onChangePageMoveis = this.onChangePageMoveis.bind(this);
    this.onChangeFileMoveis = this.onChangeFileMoveis.bind(this);
    this.onClickViewModalMoveis = this.onClickViewModalMoveis.bind(this);
    /*
        MOVEIS - End
    */

    /*
        GENERICOS - Begin
    */
    this.handlerModalCloseUpFichaTecnica = this.handlerModalCloseUpFichaTecnica.bind(this);
    this.handleChangeSelectFornecedores = this.handleChangeSelectFornecedores.bind(this);
    this.loadCategoriaFornecedor = this.loadCategoriaFornecedor.bind(this);
    /*
        GENERICOS - End
    */

  };

  componentDidMount() {
    this.isVisaoTok = this.context.user.isVisaoTok;
    this.permissions = this.context.user.permissions;

    if (!this.isVisaoTok) {
      this.loadCategoriaFornecedor();
    }

    if (this.isVisaoTok) {
      this.loadFornecedores();
    }

    this.loadSituacoes();
    this.handlerLoadSearchFilterTagAcessorios();
    this.handlerLoadSearchFilterTagMoveis();

    //auditoria
    // TagManager.dataLayer({
    //     dataLayer: {
    //       event: 'event',
    //       eventCategory: 'tokstok:fornecedores:qualidade',
    //       eventAction: 'componentDidMount',
    //       eventLabel: 'componente-qualidade',
    //     }
    // });

    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    Log.info(token, "Efetuado carregamento da tela Qualidade!");
  };

  /*
      GENERICOS - Begin
  */
  loadFornecedores = HelperGenericos(this).loadFornecedores;
  loadSituacoes = HelperGenericos(this).loadSituacoes;
  handlerChangeTab = HelperGenericos(this).handlerChangeTab;
  handlerChangeIndex = HelperGenericos(this).handlerChangeIndex;
  handlerModalCloseUpFichaTecnica = HelperGenericos(this).handlerModalCloseUpFichaTecnica;
  handleChangeSelectFornecedores = HelperGenericos(this).handleChangeSelectFornecedores;
  loadCategoriaFornecedor = HelperGenericos(this).loadCategoriaFornecedor;
  toggleSnackbarFilterValidation = HelperGenericos(this).toggleSnackbarFilterValidation;
  setMessageSnackbarFilterValidation = HelperGenericos(this).setMessageSnackbarFilterValidation;
  /*
      GENERICOS - End
  */

  /*
      ACESSORIOS - Begin
  */
  loadAcessorios = HelperAcessorios(this).loadAcessorios;
  handlerChangeSearchFieldAcessorios = HelperAcessorios(this).handlerChangeSearchFieldAcessorios;
  handlerChangeSearchFieldExternalAcessorios = HelperAcessorios(this).handlerChangeSearchFieldExternalAcessorios;
  handlerClickSearchFieldExternalAcessorios = HelperAcessorios(this).handlerClickSearchFieldExternalAcessorios;
  handlerLoadSearchFilterTagAcessorios = HelperAcessorios(this).handlerLoadSearchFilterTagAcessorios;
  handlerSelectCheckboxAcessorios = HelperAcessorios(this).handlerSelectCheckboxAcessorios;
  handlerClickCheckboxAcessorios = HelperAcessorios(this).handlerClickCheckboxAcessorios;
  handlerClearCheckboxAcessorios = HelperAcessorios(this).handlerClearCheckboxAcessorios;
  handlerChangeSearchFilterTagAcessorios = HelperAcessorios(this).handlerChangeSearchFilterTagAcessorios;
  handlerClearFilterTagAcessorios = HelperAcessorios(this).handlerClearFilterTagAcessorios;
  handlerChangeStatusAcessorios = HelperAcessorios(this).handlerChangeStatusAcessorios;
  handlerChangeSituacoesAcessorios = HelperAcessorios(this).handlerChangeSituacoesAcessorios;
  handlerCleanFiltersAcessorios = HelperAcessorios(this).handlerCleanFiltersAcessorios;
  handlerAplicarFiltersAcessorios = HelperAcessorios(this).handlerAplicarFiltersAcessorios;
  handlerCheckboxAllAcessorios = HelperAcessorios(this).handlerCheckboxAllAcessorios;
  onChangePageAcessorios = HelperAcessorios(this).onChangePageAcessorios;
  onClickViewModalAcessorios = HelperAcessorios(this).onClickViewModalAcessorios;
  onChangeFileAcessorios = HelperAcessorios(this).onChangeFileAcessorios;
  onUpFileAcessorios = HelperAcessorios(this).onUpFileAcessorios;
  handleChangeGruposAcessorios = HelperAcessorios(this).handleChangeGruposAcessorios;
  handleChangeFamiliasAcessorios = HelperAcessorios(this).handleChangeFamiliasAcessorios;
  disableSelectFamiliasAcessorios = HelperAcessorios(this).disableSelectFamilias;
  /*
      ACESSORIOS - End
  */

  /*
      MOVEIS - Begin
  */
  loadMoveis = HelperMoveis(this).loadMoveis;
  handlerChangeSearchFieldMoveis = HelperMoveis(this).handlerChangeSearchFieldMoveis;
  handlerChangeSearchFieldExternalMoveis = HelperMoveis(this).handlerChangeSearchFieldExternalMoveis;
  handlerClickSearchFieldExternalMoveis = HelperMoveis(this).handlerClickSearchFieldExternalMoveis;
  handlerLoadSearchFilterTagMoveis = HelperMoveis(this).handlerLoadSearchFilterTagMoveis;
  handlerSelectCheckboxMoveis = HelperMoveis(this).handlerSelectCheckboxMoveis;
  handlerClickCheckboxMoveis = HelperMoveis(this).handlerClickCheckboxMoveis;
  handlerClearCheckboxMoveis = HelperMoveis(this).handlerClearCheckboxMoveis;
  handlerChangeSearchFilterTagMoveis = HelperMoveis(this).handlerChangeSearchFilterTagMoveis;
  handlerClearFilterTagMoveis = HelperMoveis(this).handlerClearFilterTagMoveis;
  handlerChangeStatusMoveis = HelperMoveis(this).handlerChangeStatusMoveis;
  handlerChangeSituacoesMoveis = HelperMoveis(this).handlerChangeSituacoesMoveis;
  handlerCleanFiltersMoveis = HelperMoveis(this).handlerCleanFiltersMoveis;
  handlerAplicarFiltersMoveis = HelperMoveis(this).handlerAplicarFiltersMoveis;
  handlerCheckboxAllMoveis = HelperMoveis(this).handlerCheckboxAllMoveis;
  handlerChangeStatusMoveis = HelperMoveis(this).handlerChangeStatusMoveis;
  onChangePageMoveis = HelperMoveis(this).onChangePageMoveis;
  onClickViewModalMoveis = HelperMoveis(this).onClickViewModalMoveis;
  onChangeFileMoveis = HelperMoveis(this).onChangeFileMoveis;
  handleChangeGruposMoveis = HelperMoveis(this).handleChangeGruposMoveis;
  handleChangeFamiliasMoveis = HelperMoveis(this).handleChangeFamiliasMoveis;
  disableSelectFamiliasMoveis = HelperMoveis(this).disableSelectFamilias;
  /*
      MOVEIS - End
  */

  render() {
    return (
      <>
        <Helmet>
          <title>{`${process.env.REACT_APP_TITLE} - Qualidade`}</title>
        </Helmet>
        <Cabecario title={this.state.title} />
        <br />
        {this.permissions['filtro-fornecedor'] &&
          <Filter {...this} />
        }
        <br />
        <Tabs {...this} />
        {this.state.isError &&
          <div align="center">
            <Error text={this.state.error} />
          </div>
        }
        <Loader {...this} />
        <Alerta ref={this.childAlert} />
        <ModalFichaTecnicaSucesso
          isModalOpen={this.state.openModalUpFichaTecnica}
          handleDialogModal={this.handlerModalCloseUpFichaTecnica}
        />
        <input
          id="inputFileMoveis"
          type="file"
          ref={(ref) => this.childUploadMoveis = ref}
          style={{ display: 'none' }}
          onChange={this.onChangeFileMoveis.bind(this)}
          accept=".pdf, .PDF"
        />
        <input
          id="inputFileAcessorios"
          type="file"
          ref={(ref) => this.childUploadAcessorios = ref}
          style={{ display: 'none' }}
          onChange={this.onChangeFileAcessorios.bind(this)}
          accept=".pdf, .PDF"
        />

        <SnackbarFilterValidation
          isOpen={this.state.isOpenSnackbarFilterValidation}
          message={this.state.messageSnackbarFilterValidation}
          toggle={this.toggleSnackbarFilterValidation}
        />
      </>
    );
  };

};